import React from 'react';
import Layout from '@/components/Layout/Layout';
import LocationHeader from '@/components/Locations/LocationHeader';
import LocationMap from '@/components/Locations/LocationMap';
import WhyChooseUs from '@/components/Locations/WhyChooseUs';
import BrandPartners from '@/components/Locations/BrandPartners';
import ServicesSection from '@/components/Locations/ServicesSection';
import EmergencyServices from '@/components/Locations/EmergencyServices';
import ServiceAreas from '@/components/Locations/ServiceAreas';
import InsuranceClaims from '@/components/Locations/InsuranceClaims';
import CallToAction from '@/components/Locations/CallToAction';
import Testimonials from '@/components/Locations/Testimonials';

const RockyMountNCPage = () => {
  const businessAddress = "104 S. Business Ct, Rocky Mount, NC 27804";
  const mapSrc = "https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d6455.256085745063!2d-77.776487!3d36.004954!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x89ac335c924526fb%3A0xa2947a49cea69311!2sCAROLINA%20TROPHY%20ROOFS!5e0!3m2!1sen!2sus!4v1750119102391!5m2!1sen!2sus";
  const locationName = "Rocky Mount";
  const phone = "(252) 302-2003";
  const email = "claims@CarolinaTrophy";

  const directions = [
    "From I-95: Take Exit 145 (US-64 West), continue 2.5 miles, turn right on Business Court",
    "From Wilson: Take US-264 West for 18 miles, merge onto US-64 West, turn right on Business Court",
    "From Tarboro: Take US-64 West for 25 miles, turn right on Business Court",
    "Parking: Free customer parking available directly in front of building"
  ];

  return (
    <Layout>
      <div className="container mx-auto py-12 px-4 sm:px-6 lg:px-8">
        <div className="max-w-6xl mx-auto">
          <LocationHeader
            title="Carolina Trophy Roofs Rocky Mount: Premier Roofing Services in North Central North Carolina"
            address={businessAddress}
            phone={phone}
            description="Serving Rocky Mount, Wilson, Tarboro, Nashville, Battleboro, and all of Nash & Edgecombe Counties with expert roofing solutions since 2012"
          />

          <LocationMap
            mapSrc={mapSrc}
            businessName={locationName}
            directions={directions}
          />

          <WhyChooseUs
            locationName={locationName}
            description="At Carolina Trophy Roofs Rocky Mount, we understand the unique challenges that North Central North Carolina's climate presents to your home's most critical defense system. Located in the heart of Nash County at 104 S. Business Ct, our team of certified roofing professionals has been protecting Rocky Mount families and businesses from severe weather, humidity cycles, and the demanding Piedmont-Coastal Plain transition climate for over a decade."
          />

          <BrandPartners />

          <ServicesSection locationName={locationName} />

          <EmergencyServices locationName={locationName} phone={phone} />

          <ServiceAreas locationName={locationName} />

          <InsuranceClaims
            locationName={locationName}
            email={email}
            phone={phone}
          />

          <CallToAction
            locationName={locationName}
            address={businessAddress}
            phone={phone}
            email={email}
          />

          <Testimonials locationName={locationName} />
        </div>
      </div>
    </Layout>
  );
};

export default RockyMountNCPage;
